export class AuthEndPoint {
  static LOGIN=`/api/v1/auth/signin`
  static SIGNUP=`/api/v1/auth/signup`
  static CHANGEPASSWORD=`/api/v1/auth/changePassword`
  static DELETEACOUNTE=`/api/v1/auth/deleteMe`
  static EDITPROFILE=`/api/v1/auth/editProfile`
  static LOGOUT=`/api/v1/auth/logout`
  static GITINFO=`/api/v1/auth/profileData`
  static FORGOTPASSWORD=`/api/v1/auth/forgotPassword`
  static VERIFY=`/api/v1/auth/verifyResetCode`
  static RESETPASSWORD=`/api/v1/auth/resetPassword`
  static UploadProfilePhoto=`/api/v1/auth/upload-photo`
  static UserData=`/api/v1/auth/profile-data`
  static DeleteAccount=`/api/v1/auth/deleteMe`
  static EditProfile=`/api/v1/auth/editProfile`
  static ChangePassword=`/api/v1/auth/change-password`
}
